// extracted by mini-css-extract-plugin
export default {"content":"WorkspacePlanSwitch_content__ikAfF","head":"WorkspacePlanSwitch_head__bRWJM","body":"WorkspacePlanSwitch_body__HKzbD"};